import {
  ARROW_LEFT,
  ARROW_RIGHT,
  BACKSPACE,
  DELETE,
  ENTER,
  IE_DELETE,
  IE_LEFT,
  IE_RIGHT,
  TAB,
} from '~/constants/keyCodes';

// 'Left', 'Right' and "Del" values are IE specific
const alwaysAllowedKeys = new Set([
  TAB,
  BACKSPACE,
  ARROW_LEFT,
  IE_LEFT,
  ARROW_RIGHT,
  IE_RIGHT,
  DELETE,
  IE_DELETE,
  ENTER,
]);

export const handleKeyRestrictions = (
  $event: any,
  options: { allowedKeys: string[]; allowLetter: boolean } = { allowedKeys: [], allowLetter: false },
) => {
  if (alwaysAllowedKeys.has($event.key) || new Set(options.allowedKeys).has($event.key)) return;
  if (['v', 'c', 'x', 'z', 'a'].includes($event.key) && $event.ctrlKey) return;
  if (options.allowLetter) {
    const letterMatcher = /([A-Za-z]).*/g;
    if (letterMatcher.test($event.key)) return;
  }
  if (isNaN(+$event.key) || $event.key === null || $event.key === ' ') $event.preventDefault();
};
